export class ListView<T> {
    public items: Array<T>;

    constructor(items: Array<T>) {
        this.items = items;
    }
}
